// UserContext.js
import React, { createContext, useState, useEffect } from "react";
import { fetchProfile, AdminfetchProfile, EmpfetchProfile } from "../api/api";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [name, setName] = useState(localStorage.getItem("full_name") || "");
  const [image, setImage] = useState(
    localStorage.getItem("profile_image") || ""
  );

  // Check if user is authenticated
  const isAuthenticated = () => {
    return !!(
      localStorage.getItem("authToken") ||
      localStorage.getItem("adminToken") ||
      localStorage.getItem("employeeToken")
    );
  };

  // Fetch profile data and update context
  const refreshProfile = async (profileFetchFn = null) => {
    if (!isAuthenticated()) {
      return;
    }

    // Determine which API to use based on token or provided function
    let fetchFn = profileFetchFn;
    if (!fetchFn) {
      if (localStorage.getItem("adminToken")) {
        fetchFn = AdminfetchProfile;
      } else if (localStorage.getItem("employeeToken")) {
        fetchFn = EmpfetchProfile;
      } else {
        fetchFn = fetchProfile;
      }
    }

    try {
      const response = await fetchFn();
      if (response && response.data) {
        const { full_name, profile_image } = response.data;

        // Update name if it exists
        if (full_name) {
          setName(full_name);
          localStorage.setItem("full_name", full_name);
        }

        // Update image if it exists (this will be the SAS-enriched URL)
        if (profile_image) {
          setImage(profile_image);
          localStorage.setItem("profile_image", profile_image);
        }
      }
    } catch (error) {
      console.error("Failed to fetch profile:", error);
      // Don't clear existing data on error, just log it
    }
  };


  // Listen for token refresh events and refresh profile accordingly
  useEffect(() => {
    const handleTokenRefreshed = () => {
      refreshProfile();
    };

    window.addEventListener("auth:tokenRefreshed", handleTokenRefreshed);

    return () => {
      window.removeEventListener("auth:tokenRefreshed", handleTokenRefreshed);
    };
  }, []);

  const updateName = (newName) => {
    setName(newName);
    localStorage.setItem("full_name", newName);
  };

  const updateImage = (newImage) => {
    setImage(newImage);
    localStorage.setItem("profile_image", newImage);
  };

  return (
    <UserContext.Provider value={{ name, updateName, image, updateImage }}>
      {children}
    </UserContext.Provider>
  );
};
